export var gtmEvents = /*#__PURE__*/ function(gtmEvents) {
    gtmEvents["AccountManagerMessage"] = "account-manager-message";
    gtmEvents["AddInterviewNotes"] = "add-interview-notes";
    gtmEvents["CandidateExtendOffer"] = "candidate-extend-offer";
    gtmEvents["CandidateViewModal"] = "candidate-view-modal";
    gtmEvents["CandidateViewThumbUp"] = "candidate-view-thumb-up";
    gtmEvents["CandidateViewThumbDown"] = "candidate-view-thumb-down";
    gtmEvents["CandidateViewViewProfile"] = "candidate-view-view-profile";
    gtmEvents["ClickEmployerCandidate"] = "click-employer-candidate";
    gtmEvents["ClickEmployerJob"] = "click-employer-job";
    gtmEvents["ClickEmployerJobCandidate"] = "click-employer-job-candidate";
    gtmEvents["ClickJobCard"] = "click-job-card";
    gtmEvents["ClientPortalJobDescriptionAI"] = "client-portal-job-description-ai";
    gtmEvents["ClientPortalCreateNewJob"] = "client-portal-create-new-job";
    gtmEvents["ClientPortalRequestTalentList"] = "client-portal-request-talent-list";
    gtmEvents["deleteTalentPool"] = "delete-talent-pool";
    gtmEvents["FormBasicUserInfo"] = "form-basic-user-info";
    gtmEvents["FormCandidateDetail"] = "form-candidate-detail";
    gtmEvents["FormCandidateNotesDelete"] = "form-candidate-notes-delete";
    gtmEvents["FormCandidateSearch"] = "form-candidates-search";
    gtmEvents["FormChangePassword"] = "form-change-password";
    gtmEvents["FormCommunicationPreference"] = "form-communication-preference";
    gtmEvents["FormCreatePassword"] = "form-create-password";
    gtmEvents["FormCreateJob"] = "form-create-job";
    gtmEvents["FormDeleteAccount"] = "form-delete-account";
    gtmEvents["FormEditJob"] = "form-edit-job";
    gtmEvents["FormPublishJob"] = "form-publish-job";
    gtmEvents["FormEmployerJobAddCandidateBullhorn"] = "form-employer-job-add-candidate-bullhorn";
    gtmEvents["FormEmployerJobAddCandidateManual"] = "form-employer-job-add-candidate-manual";
    gtmEvents["FormEmployerJobCandidateExists"] = "form-employer-job-add-candidate-exists";
    gtmEvents["FormEmployerJobCandidateMultiple"] = "form-employer-job-add-candidate-multiple-jobs";
    gtmEvents["FormEmployerJobs"] = "form-employer-jobs";
    gtmEvents["FormExpenses"] = "form-expenses";
    gtmEvents["FormJobActivityCandidates"] = "form-job-activity-candidates";
    gtmEvents["FormJobExperience"] = "form-job-experience";
    gtmEvents["FormJobSearch"] = "form-job-search";
    gtmEvents["FormJobSubmit"] = "form-job-submit";
    gtmEvents["FormJobsRequiringAttention"] = "form-jobs-requiring-attention";
    gtmEvents["FormLogin"] = "form-login";
    gtmEvents["FormMsSSOLogin"] = "form-ms-sso-login";
    gtmEvents["FormPaymentPaid"] = "form-payment-paid";
    gtmEvents["FormPaymentPending"] = "form-payment-pending";
    gtmEvents["FormPaymentReports"] = "form-payment-reports";
    gtmEvents["FormProfileDetails"] = "form-profile-details";
    gtmEvents["FormResetPassword"] = "form-reset-password";
    gtmEvents["FormSearchBullhornCandidate"] = "form-search-bullhorn-candidate";
    gtmEvents["FormSearchManualCandidate"] = "form-search-manual-candidate";
    gtmEvents["FormSearchTalentPools"] = "form-search-talent-pools";
    gtmEvents["FormSignUp"] = "form-signup";
    gtmEvents["FormSignUpEmail"] = "form-signup-email";
    gtmEvents["FormTimesheets"] = "form-timesheets";
    gtmEvents["FormUploadAvatar"] = "form-upload-avatar";
    gtmEvents["FormWorkOrders"] = "form-work-orders";
    gtmEvents["FormWorkPreference"] = "form-work-preference";
    gtmEvents["InitialLogin"] = "initial-login";
    gtmEvents["ContractorSignup"] = "contractor-signup";
    gtmEvents["InviteCollaborator"] = "invite-collaborator";
    gtmEvents["InterviewSendRequest"] = "interview-send-request";
    gtmEvents["ImportTalentPool"] = "import-talent-pool";
    gtmEvents["ViewTalentPool"] = "view-talent-pool";
    gtmEvents["GenerateAiJobDescription"] = "generate-ai-job-description";
    gtmEvents["GenerateAiCandidateHighlights"] = "generate-ai-candidate-highlights";
    gtmEvents["GenerateAiResumeTips"] = "generate-ai-resume-tips";
    gtmEvents["ViewCandidates"] = "view-candidates";
    gtmEvents["OpenReloadingDialogForNewBuildNumber"] = "open-reloading-dialog-for-new-build-number";
    gtmEvents["PostponeReceivingNewBuildNumber"] = "postpone-receiving-new-build-number";
    gtmEvents["CallingNewBuildNumberApi"] = "calling-new-build-number-api";
    gtmEvents["ViewDocument"] = "view-document";
    gtmEvents["InitializingMsSsoLogin"] = "initializing-ms-sso-login";
    gtmEvents["ToggleResourceCentreSalesListView"] = "toggle-resource-centre-sales-list-view";
    gtmEvents["ToggleResourceCentreSalesDetailView"] = "toggle-resource-centre-sales-detail-view";
    gtmEvents["ClickResourceCentreShareBtn"] = "click-resource-centre-share-btn";
    gtmEvents["ClickResourceCentreDeactivateShareBtn"] = "click-resource-centre-deactivate-share-btn";
    gtmEvents["ClickResourceCentreActivateShareBtn"] = "click-resource-centre-activate-share-btn";
    gtmEvents["ResourceCentreGenerateShareLink"] = "resource-centre-generate-share-link";
    gtmEvents["ResourceCentreDeactivateShareLink"] = "resource-centre-deactivate-share-link";
    gtmEvents["ResourceCentreActivateShareLink"] = "resource-centre-activate-share-link";
    gtmEvents["ResourceCentreShareCopyLink"] = "resource-centre-share-copy-link";
    gtmEvents["ClickResourceCentreSalesResourceCard"] = "click-resource-centre-sales-resource-card";
    gtmEvents["ClickResourceCentreRelatedContentCard"] = "click-resource-centre-related-content-card";
    gtmEvents["ClickResourceCentreSalesContentCreateBtn"] = "click-resource-centre-sales-content-create-btn";
    gtmEvents["ClickResourceCentreSalesDetailViewEditBtn"] = "click-resource-centre-sales-detail-view-edit-btn";
    gtmEvents["ResourceCentreSalesCreateContent"] = "resource-centre-sales-create-content";
    gtmEvents["ResourceCentreSalesDetailViewEditModeSave"] = "resource-centre-sales-detail-view-edit-mode-save";
    gtmEvents["ResourceCentreSalesReplaceContent"] = "resource-centre-sales-replace-content";
    gtmEvents["ResourceCentreProspectDetailView"] = "resource-centre-prospect-detail-view";
    gtmEvents["ResourceCentreAnonymousDetailVisitedPage"] = "resource-centre-anonymous-detail-visited-page";
    gtmEvents["ResourceCentreAnonymousDetailAuthenticationModalTriggered"] = "resource-centre-anonymous-detail-authentication-modal-triggered";
    gtmEvents["ResourceCentreAnonymousDetailValidateEmail"] = "resource-centre-anonymous-detail-validate-email";
    gtmEvents["ResourceCentreAnonymousDetailOTPLogin"] = "resource-centre-anonymous-detail-otp-login";
    gtmEvents["ResourceCentreAnonymousDetailPasswordLogin"] = "resource-centre-anonymous-detail-password-login";
    gtmEvents["ResourceCentreDetailBadgeEmailClick"] = "resource-centre-detail-badge-email-click";
    return gtmEvents;
}({});
export var gtmEventsPrefix = /*#__PURE__*/ function(gtmEventsPrefix) {
    gtmEventsPrefix["Notification"] = "notification-";
    return gtmEventsPrefix;
}({});
export var GtmFormSubmissionStatus = /*#__PURE__*/ function(GtmFormSubmissionStatus) {
    GtmFormSubmissionStatus["success"] = "true";
    GtmFormSubmissionStatus["failed"] = "false";
    return GtmFormSubmissionStatus;
}({});
